import { useEffect, useState } from "react";
import axios from "axios";
import { Pencil, Trash2 } from "lucide-react";
import "../../styles/settings/DraftSectionManagement.css";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/draft-sections`;

const DraftSectionManagement = () => {
  const [sections, setSections] = useState([]);
  const token = localStorage.getItem("token");

  const [showModal, setShowModal] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [sectionName, setSectionName] = useState("");

  /* ================= LOAD ================= */
  const loadSections = async () => {
    try {
      const res = await axios.get(API_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSections(res.data);
    } catch (err) {
      console.error("Load section failed", err);
    }
  };

  useEffect(() => {
    loadSections();
  }, []);

  /* ================= OPEN ADD ================= */
  const openAdd = () => {
    setEditingSection(null);
    setSectionName("");
    setShowModal(true);
  };

  /* ================= OPEN EDIT ================= */
  const openEdit = (item) => {
    setEditingSection(item);
    setSectionName(item.section_name);
    setShowModal(true);
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!sectionName.trim()) return;

    try {
      if (editingSection) {
        await axios.put(
          `${API_URL}/${editingSection.section_id}`,
          { section_name: sectionName },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          API_URL,
          { section_name: sectionName },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      setShowModal(false);
      loadSections();
    } catch (err) {
      alert("Operation failed");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this section name?")) return;

    try {
      await axios.delete(`${API_URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      loadSections();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <div className="settings-page">
      {/* ✅ COMMON HEADER */}
      <div className="settings-header">
        <h2>Draft Section Management</h2>
        <button className="add-btn" onClick={openAdd}>
          + Add New Section
        </button>
      </div>

      {/* ✅ COMMON TABLE */}
      <table className="settings-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Section Name</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {sections.map((section, index) => (
            <tr key={section.section_id}>
              <td>{index + 1}</td>
              <td>{section.section_name}</td>

              <td>
                <button
                  className="action-btn"
                  onClick={() => openEdit(section)}
                  title="Edit"
                >
                  <Pencil size={16} />
                </button>

                <button
                  className="action-btn delete"
                  onClick={() => handleDelete(section.section_id)}
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* MODAL */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Draft Section</h3>

            <label>Section Name</label>
            <input
              value={sectionName}
              onChange={(e) => setSectionName(e.target.value)}
              placeholder="Enter section name"
            />

            <div className="modal-actions">
              <button
                className="secondary-btn"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="primary-btn" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DraftSectionManagement;
